import "core-js/modules/es.array.index-of";
import "core-js/modules/es.string.replace";

/**
 * oss 图片 url 优化处理
 * @param url
 * @param options
 */
import { env } from '../services/env';
export var supportsWebp = false;

if (!process.env.SERVER) {
  supportsWebp = function () {
    try {
      return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0;
    } catch (err) {
      return false;
    }
  }();
}

export function ossUrl(url, options) {
  if (options === void 0) {
    options = {};
  }

  if (!/dancf\.com/.test(url)) return url;
  var _options = options,
      width = _options.width,
      height = _options.height,
      _options$type = _options.type,
      type = _options$type === void 0 ? 'webp' : _options$type,
      scaleType = _options.scaleType,
      _options$minDpr = _options.minDpr,
      minDpr = _options$minDpr === void 0 ? 1.5 : _options$minDpr,
      _options$useDpr = _options.useDpr,
      useDpr = _options$useDpr === void 0 ? true : _options$useDpr,
      _options$resizeType = _options.resizeType,
      resizeType = _options$resizeType === void 0 ? 0 : _options$resizeType,
      crop = _options.crop;
  var src = url + '?x-oss-process=';

  if ((width || height) && !/\.gif$/.test(url)) {
    src += 'image/resize'; // 最大限制 2， 防止图片过大， 最小1.5 保证图片清晰

    var dpr = useDpr ? Math.min(2, env.isBrowser ? Math.max(devicePixelRatio, minDpr) : minDpr) : 1;

    if (width) {
      src += ",w_" + Math.round(width * dpr);
    }

    if (height) {
      src += ",h_" + Math.round(height * dpr);
    }

    if (scaleType) {
      // https://help.aliyun.com/document_detail/44688.html?spm=a2c4g.11186623.6.1383.36e335a8pxsRMg
      src += ",m_" + scaleType;
    }

    if (resizeType === 6) {
      src += ',type_6';
    }

    if (crop) {
      src += '/crop';

      if (crop.width) {
        src += ",w_" + Math.round(crop.width);
      }

      if (crop.height) {
        src += ",h_" + Math.round(crop.height);
      }
    }

    src += '/interlace,1,';
  }

  if (type && !/\.svg$/.test(url)) {
    if (type === 'webp' || /\.webp$/.test(url)) {
      if (options.supportWebp || supportsWebp) {
        src += "image/format," + type + ",";
      } else if (options.allowJPGOnUnsupportedWebp && !/\.gif$/.test(url)) {
        src += 'image/format,jpg,';
      }
    } else {
      src += "image/format," + type + ",";
    }
  }

  if (/\?x-oss-process=$/.test(src)) return url;
  return src.replace(/,$/, '');
}